import React, { useCallback } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { FILTER_TYPES } from 'Pods/LazyLoaded/ReviewsSidebar/constants'

function CommentButton() {
  const handleCommentClick = useCallback(() => {
    window.dispatchEvent(new CustomEvent('open-review-modal', {
      detail: { filterBy: FILTER_TYPES.COMMENTS },
    }))
  }, [])

  return (
    <Button
      type="primary-warning"
      customClass="pricing-area__actions-button pricing-area__actions-right-button"
      size="large"
      onClick={handleCommentClick}
      aria-label="Comment"
    >
      Comment
    </Button>
  )
}

export default CommentButton
